if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper, .disclosure__list'),
      };
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.addEventListener('focusout', this.closeSelector.bind(this));

      if (this.elements.button) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
      }

      this.querySelectorAll('a[data-value]').forEach((item) => {
        item.addEventListener('mousedown', (event) => {
          event.preventDefault();
          this.onItemClick(event);
        });
      });
    }

    hidePanel() {
      if (!this.elements.button || !this.elements.panel) return;
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button?.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (!form || !this.elements.input) return;
      this.elements.input.value = event.currentTarget.dataset.value;
      form.submit();
    }

    openSelector(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.elements.button || !this.elements.panel) return;
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (!this.elements.panel.hasAttribute('hidden')).toString()
      );
    }

    closeSelector(event) {
      if (!this.contains(event.target) || (event.relatedTarget && !this.contains(event.relatedTarget))) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
